import { Flex, Switch, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React, { useRef } from "react";
import { Filters, useProjectFilter } from "../hooks/useProjectFilter";

type Props = {
  filterKey: keyof Filters;
  label: string;
};

export const ProjectFilterItem = observer((props: Props) => {
  const { filters, setFilter } = useProjectFilter();
  const switchRef = useRef<HTMLButtonElement>(null);

  function handleFilterClick(e: boolean) {
    setFilter(props.filterKey, e ? "true" : undefined);
  }

  return (
    <Flex gap="small" align="center">
      <Switch
        ref={switchRef}
        checked={!!filters[props.filterKey]}
        onClick={(flag) => handleFilterClick(flag)}
      />
      <Typography.Text
        onClick={() => switchRef.current?.click()}
        style={{ cursor: "pointer" }}
      >
        {props.label}
      </Typography.Text>
    </Flex>
  );
});
